import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Store } from '@ngrx/store';

import { OrderCancelModal } from '../../models/orders-type.model';
import { CancelOrder, CancelSubOrder } from '../../store/orders-type.actions';

import { DialogRef } from '@ui/dialog/dialog-ref';

@Component({
    selector: 'order-cancel',
    templateUrl: './order-cancel.component.html',
    styleUrls: ['./order-cancel.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderCancelComponent {
    public hasSubOrders = this.modalRef.data.hasSubOrders;

    constructor(
        private readonly store: Store,
        private readonly modalRef: DialogRef<void, OrderCancelModal>,
    ) {}

    public closeDialog() {
        this.modalRef.close();
    }

    public cancelOrder() {
        if (!this.hasSubOrders) {
            this.store.dispatch(CancelOrder());
        } else {
            this.store.dispatch(CancelSubOrder());
        }

        this.modalRef.close();
    }
}
